import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isServiceEnabled, Services } from '../services/http/apiClient';

const PrivateRoute = () => {
  const allowed = localStorage.getItem('authAllowed') === 'true';
  console.log('🔒 PrivateRoute - authAllowed:', allowed);
  console.log('🔒 PrivateRoute - localStorage authAllowed:', localStorage.getItem('authAllowed'));
  
  if (allowed) {
    console.log('✅ Acesso autorizado, renderizando dashboard');
    return <Outlet />;
  } else {
    console.log('❌ Acesso negado, redirecionando para login');
    return <Navigate to="/login" />;
  }
}

export default PrivateRoute;

export const RequireService = ({ service, redirectTo = "/dashboard" }) => {
  const ok = isServiceEnabled(service);
  console.log(`🧩 RequireService(${service}) ->`, ok);
  return ok ? <Outlet /> : <Navigate to={redirectTo} replace />;
};

export { Services };